import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ButtonProps } from '@mui/material';

import AccountingSoftwareFreeTrialModal from '@/features/accounting-software/components/AccountingSoftwareFreeTrialModal';
import SyncButtonWithModal from '@/features/accounting-software/components/SyncButtonWithModal';

type Props = {
  isMobile?: boolean;
  sx?: ButtonProps['sx'];
};

const SyncButtonWithModalContainer = ({ isMobile, sx }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <AccountingSoftwareFreeTrialModal
        isModalOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <SyncButtonWithModal
        buttonText={
          isMobile ? (
            <FormattedMessage defaultMessage="Sync" />
          ) : (
            <FormattedMessage defaultMessage="Sync with QuickBooks, Xero or NetSuite" />
          )
        }
        onClick={() => setIsModalOpen(true)}
        sx={sx}
      />
    </>
  );
};

export type { Props as SyncButtonWithModalContainerProps };
export default SyncButtonWithModalContainer;
